import { render } from "./ContentList.vue?vue&type=template&id=f1e7fdec&scoped=true"
import script from "./ContentList.vue?vue&type=script&lang=js"
export * from "./ContentList.vue?vue&type=script&lang=js"

import "./ContentList.vue?vue&type=style&index=0&id=f1e7fdec&lang=scss&scoped=true"

import exportComponent from "/builds/web-primary/web-ask-review/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1e7fdec"]])

export default __exports__